export default {
  defaultPdfQuality: 2
}
